'use strict';

var _regeneratorRuntime = require("/codebuild/output/src122629992/src/niftron-profile/node_modules/babel-preset-react-app/node_modules/@babel/runtime/regenerator");

var _asyncToGenerator = require("/codebuild/output/src122629992/src/niftron-profile/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/asyncToGenerator");

var Bitswap = require('ipfs-bitswap');

var multiaddr = require('multiaddr');

var get = require('dlv');

var defer = require('p-defer');

var IPNS = require('../ipns');

var routingConfig = require('../ipns/routing/config');

var _require = require('../errors'),
    AlreadyInitializedError = _require.AlreadyInitializedError,
    NotEnabledError = _require.NotEnabledError;

var Components = require('./');

var createMfsPreload = require('../mfs-preload');

module.exports = function (_ref) {
  var apiManager = _ref.apiManager,
      constructorOptions = _ref.options,
      blockService = _ref.blockService,
      gcLock = _ref.gcLock,
      initOptions = _ref.initOptions,
      ipld = _ref.ipld,
      keychain = _ref.keychain,
      peerInfo = _ref.peerInfo,
      pinManager = _ref.pinManager,
      preload = _ref.preload,
      print = _ref.print,
      repo = _ref.repo;
  return /*#__PURE__*/function () {
    var _start = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee() {
      var startPromise, _apiManager$update, cancel, config, libp2p, ipnsRouting, ipns, bitswap, block, files, mfsPreload, api;

      return _regeneratorRuntime.wrap(function _callee$(_context) {
        while (1) {
          switch (_context.prev = _context.next) {
            case 0:
              startPromise = defer();
              _apiManager$update = apiManager.update({
                start: function start() {
                  return startPromise.promise;
                }
              }), cancel = _apiManager$update.cancel;
              _context.prev = 2;

              if (!repo.closed) {
                _context.next = 6;
                break;
              }

              _context.next = 6;
              return repo.open();

            case 6:
              _context.next = 8;
              return repo.config.get();

            case 8:
              config = _context.sent;

              if (config.Addresses && config.Addresses.Swarm) {
                config.Addresses.Swarm.forEach(function (addr) {
                  var ma = multiaddr(addr); // multiaddrs that go via a signalling server or other intermediary (e.g. stardust,
                  // webrtc-star) can have the intermediary's peer ID in the address, so append our
                  // peer ID to the end of it

                  var maId = ma.getPeerId();

                  if (maId && maId !== peerInfo.id.toB58String()) {
                    ma = ma.encapsulate("/p2p/".concat(peerInfo.id.toB58String()));
                  }

                  peerInfo.multiaddrs.add(ma);
                });
              }

              libp2p = Components.libp2p({
                options: constructorOptions,
                repo: repo,
                peerInfo: peerInfo,
                print: print,
                config: config
              });
              _context.next = 13;
              return libp2p.start();

            case 13:
              peerInfo.multiaddrs.forEach(function (ma) {
                return print("Swarm listening on ".concat(ma, "/p2p/").concat(peerInfo.id.toB58String()));
              });
              ipnsRouting = routingConfig({
                libp2p: libp2p,
                repo: repo,
                peerInfo: peerInfo,
                options: constructorOptions
              });
              ipns = new IPNS(ipnsRouting, repo.datastore, peerInfo, keychain, {
                pass: initOptions.pass
              });
              bitswap = new Bitswap(libp2p, repo.blocks, {
                statsEnabled: true
              });
              _context.next = 19;
              return bitswap.start();

            case 19:
              blockService.setExchange(bitswap);
              block = {
                get: Components.block.get({
                  blockService: blockService,
                  preload: preload
                }),
                put: Components.block.put({
                  blockService: blockService,
                  gcLock: gcLock,
                  preload: preload
                }),
                rm: Components.block.rm({
                  blockService: blockService,
                  gcLock: gcLock,
                  pinManager: pinManager
                }),
                stat: Components.block.stat({
                  blockService: blockService,
                  preload: preload
                })
              };
              files = Components.files({
                ipld: ipld,
                block: block,
                blockService: blockService,
                repo: repo,
                preload: preload,
                options: constructorOptions
              });
              mfsPreload = createMfsPreload({
                files: files,
                preload: preload,
                options: constructorOptions.preload
              });
              _context.next = 25;
              return Promise.all([ipns.republisher.start(), preload.start(), mfsPreload.start()]);

            case 25:
              api = createApi({
                apiManager: apiManager,
                bitswap: bitswap,
                block: block,
                blockService: blockService,
                config: config,
                constructorOptions: constructorOptions,
                files: files,
                gcLock: gcLock,
                initOptions: initOptions,
                ipld: ipld,
                ipns: ipns,
                keychain: keychain,
                libp2p: libp2p,
                mfsPreload: mfsPreload,
                peerInfo: peerInfo,
                pinManager: pinManager,
                preload: preload,
                print: print,
                repo: repo
              });
              apiManager.update(api, function () {
                return undefined;
              });
              _context.next = 34;
              break;

            case 29:
              _context.prev = 29;
              _context.t0 = _context["catch"](2);
              cancel();
              startPromise.reject(_context.t0);
              throw _context.t0;

            case 34:
              startPromise.resolve(apiManager.api);
              return _context.abrupt("return", apiManager.api);

            case 36:
            case "end":
              return _context.stop();
          }
        }
      }, _callee, null, [[2, 29]]);
    }));

    function start() {
      return _start.apply(this, arguments);
    }

    return start;
  }();
};

function createApi(_ref2) {
  var apiManager = _ref2.apiManager,
      bitswap = _ref2.bitswap,
      block = _ref2.block,
      blockService = _ref2.blockService,
      config = _ref2.config,
      constructorOptions = _ref2.constructorOptions,
      files = _ref2.files,
      gcLock = _ref2.gcLock,
      initOptions = _ref2.initOptions,
      ipld = _ref2.ipld,
      ipns = _ref2.ipns,
      keychain = _ref2.keychain,
      libp2p = _ref2.libp2p,
      mfsPreload = _ref2.mfsPreload,
      peerInfo = _ref2.peerInfo,
      pinManager = _ref2.pinManager,
      preload = _ref2.preload,
      print = _ref2.print,
      repo = _ref2.repo;
  var dag = {
    get: Components.dag.get({
      ipld: ipld,
      preload: preload
    }),
    resolve: Components.dag.resolve({
      ipld: ipld,
      preload: preload
    }),
    tree: Components.dag.tree({
      ipld: ipld,
      preload: preload
    })
  };
  var object = {
    data: Components.object.data({
      ipld: ipld,
      preload: preload
    }),
    get: Components.object.get({
      ipld: ipld,
      preload: preload
    }),
    links: Components.object.links({
      dag: dag
    }),
    new: Components.object.new({
      ipld: ipld,
      preload: preload
    }),
    patch: {
      addLink: Components.object.patch.addLink({
        ipld: ipld,
        gcLock: gcLock,
        preload: preload
      }),
      appendData: Components.object.patch.appendData({
        ipld: ipld,
        gcLock: gcLock,
        preload: preload
      }),
      rmLink: Components.object.patch.rmLink({
        ipld: ipld,
        gcLock: gcLock,
        preload: preload
      }),
      setData: Components.object.patch.setData({
        ipld: ipld,
        gcLock: gcLock,
        preload: preload
      })
    },
    put: Components.object.put({
      ipld: ipld,
      gcLock: gcLock,
      preload: preload
    }),
    stat: Components.object.stat({
      ipld: ipld,
      preload: preload
    })
  };
  var pin = {
    add: Components.pin.add({
      pinManager: pinManager,
      gcLock: gcLock,
      dag: dag
    }),
    ls: Components.pin.ls({
      pinManager: pinManager,
      dag: dag
    }),
    rm: Components.pin.rm({
      pinManager: pinManager,
      gcLock: gcLock,
      dag: dag
    })
  }; // FIXME: resolve this circular dependency

  dag.put = Components.dag.put({
    ipld: ipld,
    pin: pin,
    gcLock: gcLock,
    preload: preload
  });
  var add = Components.add({
    block: block,
    preload: preload,
    pin: pin,
    gcLock: gcLock,
    options: constructorOptions
  });
  var isOnline = Components.isOnline({
    libp2p: libp2p
  });

  var dhtNotEnabled = /*#__PURE__*/function () {
    var _ref3 = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee2() {
      return _regeneratorRuntime.wrap(function _callee2$(_context2) {
        while (1) {
          switch (_context2.prev = _context2.next) {
            case 0:
              throw new NotEnabledError('dht not enabled');

            case 1:
            case "end":
              return _context2.stop();
          }
        }
      }, _callee2);
    }));

    return function dhtNotEnabled() {
      return _ref3.apply(this, arguments);
    };
  }();

  var dht = get(libp2p, '_config.dht.enabled', false) ? Components.dht({
    libp2p: libp2p,
    repo: repo
  }) : {
    get: dhtNotEnabled,
    put: dhtNotEnabled,
    findProvs: dhtNotEnabled,
    findPeer: dhtNotEnabled,
    provide: dhtNotEnabled,
    query: dhtNotEnabled
  };
  var dns = Components.dns();
  var name = {
    pubsub: {
      cancel: Components.name.pubsub.cancel({
        ipns: ipns,
        options: constructorOptions
      }),
      state: Components.name.pubsub.state({
        ipns: ipns,
        options: constructorOptions
      }),
      subs: Components.name.pubsub.subs({
        ipns: ipns,
        options: constructorOptions
      })
    },
    publish: Components.name.publish({
      ipns: ipns,
      dag: dag,
      peerInfo: peerInfo,
      isOnline: isOnline,
      keychain: keychain,
      options: constructorOptions
    }),
    resolve: Components.name.resolve({
      dns: dns,
      ipns: ipns,
      peerInfo: peerInfo,
      isOnline: isOnline,
      options: constructorOptions
    })
  };
  var resolve = Components.resolve({
    name: name,
    ipld: ipld
  });
  var refs = Components.refs({
    ipld: ipld,
    resolve: resolve,
    preload: preload
  });
  refs.local = Components.refs.local({
    repo: repo
  });

  var pubsubNotEnabled = /*#__PURE__*/function () {
    var _ref4 = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee3() {
      return _regeneratorRuntime.wrap(function _callee3$(_context3) {
        while (1) {
          switch (_context3.prev = _context3.next) {
            case 0:
              throw new NotEnabledError('pubsub not enabled');

            case 1:
            case "end":
              return _context3.stop();
          }
        }
      }, _callee3);
    }));

    return function pubsubNotEnabled() {
      return _ref4.apply(this, arguments);
    };
  }();

  var pubsub = get(constructorOptions, 'config.Pubsub.Enabled', get(config, 'Pubsub.Enabled', true)) ? Components.pubsub({
    libp2p: libp2p
  }) : {
    subscribe: pubsubNotEnabled,
    unsubscribe: pubsubNotEnabled,
    publish: pubsubNotEnabled,
    ls: pubsubNotEnabled,
    peers: pubsubNotEnabled
  };
  var api = {
    add: add,
    bitswap: {
      stat: Components.bitswap.stat({
        bitswap: bitswap
      }),
      unwant: Components.bitswap.unwant({
        bitswap: bitswap
      }),
      wantlist: Components.bitswap.wantlist({
        bitswap: bitswap
      })
    },
    block: block,
    bootstrap: {
      add: Components.bootstrap.add({
        repo: repo
      }),
      list: Components.bootstrap.list({
        repo: repo
      }),
      rm: Components.bootstrap.rm({
        repo: repo
      })
    },
    cat: Components.cat({
      ipld: ipld,
      preload: preload
    }),
    config: Components.config({
      repo: repo
    }),
    dag: dag,
    dht: dht,
    dns: dns,
    files: files,
    get: Components.get({
      ipld: ipld,
      preload: preload
    }),
    id: Components.id({
      peerInfo: peerInfo,
      libp2p: libp2p
    }),
    init: function () {
      var _init = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee4() {
        return _regeneratorRuntime.wrap(function _callee4$(_context4) {
          while (1) {
            switch (_context4.prev = _context4.next) {
              case 0:
                throw new AlreadyInitializedError();

              case 1:
              case "end":
                return _context4.stop();
            }
          }
        }, _callee4);
      }));

      function init() {
        return _init.apply(this, arguments);
      }

      return init;
    }(),
    // eslint-disable-line require-await
    isOnline: isOnline,
    key: {
      export: Components.key.export({
        keychain: keychain
      }),
      gen: Components.key.gen({
        keychain: keychain
      }),
      import: Components.key.import({
        keychain: keychain
      }),
      info: Components.key.info({
        keychain: keychain
      }),
      list: Components.key.list({
        keychain: keychain
      }),
      rename: Components.key.rename({
        keychain: keychain
      }),
      rm: Components.key.rm({
        keychain: keychain
      })
    },
    libp2p: libp2p,
    ls: Components.ls({
      ipld: ipld,
      preload: preload
    }),
    name: name,
    object: object,
    pin: pin,
    ping: Components.ping({
      libp2p: libp2p
    }),
    pubsub: pubsub,
    refs: refs,
    repo: {
      gc: Components.repo.gc({
        gcLock: gcLock,
        pin: pin,
        pinManager: pinManager,
        refs: refs,
        repo: repo
      }),
      stat: Components.repo.stat({
        repo: repo
      }),
      version: Components.repo.version({
        repo: repo
      })
    },
    resolve: resolve,
    start: function start() {
      return apiManager.api;
    },
    stats: {
      bitswap: Components.bitswap.stat({
        bitswap: bitswap
      }),
      bw: libp2p.metrics ? Components.stats.bw({
        libp2p: libp2p
      }) : /*#__PURE__*/_asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee5() {
        return _regeneratorRuntime.wrap(function _callee5$(_context5) {
          while (1) {
            switch (_context5.prev = _context5.next) {
              case 0:
                throw new NotEnabledError('libp2p metrics not enabled');

              case 1:
              case "end":
                return _context5.stop();
            }
          }
        }, _callee5);
      })),
      repo: Components.repo.stat({
        repo: repo
      })
    },
    stop: Components.stop({
      apiManager: apiManager,
      bitswap: bitswap,
      options: constructorOptions,
      blockService: blockService,
      gcLock: gcLock,
      initOptions: initOptions,
      ipld: ipld,
      ipns: ipns,
      keychain: keychain,
      libp2p: libp2p,
      mfsPreload: mfsPreload,
      peerInfo: peerInfo,
      preload: preload,
      print: print,
      repo: repo
    }),
    swarm: {
      addrs: Components.swarm.addrs({
        libp2p: libp2p
      }),
      connect: Components.swarm.connect({
        libp2p: libp2p
      }),
      disconnect: Components.swarm.disconnect({
        libp2p: libp2p
      }),
      localAddrs: Components.swarm.localAddrs({
        peerInfo: peerInfo
      }),
      peers: Components.swarm.peers({
        libp2p: libp2p
      })
    },
    version: Components.version({
      repo: repo
    })
  };
  return api;
}